import Instafeed from 'instafeed.js';

let getToken = (yourUrl) => {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET",yourUrl,false);
    Httpreq.send(null);
    return Httpreq.responseText;          
}
 

export default () => {

    return {

        mounted() {
            const json_obj = JSON.parse(getToken('https://ig.instant-tokens.com/users/3dfbc3f7-b8f9-42f5-9dab-efac4f95c432/instagram/17841400664773372/token?userSecret=2kjrxg0dqrblvqrcw2jouf'));
            const token = json_obj['Token'];
            const feed = new Instafeed({
            accessToken: token,
            limit: 4
            });
            feed.run();
        }

    }

}